import { render, staticRenderFns } from "./FighterSlot.vue?vue&type=template&id=1863b222&"
import script from "./FighterSlot.vue?vue&type=script&lang=js&"
export * from "./FighterSlot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports